import { Components } from '@mui/material';
import { Theme } from '@mui/system';

export const buildMuiCheckboxComponent = (): Components<Omit<Theme, 'components'>>['MuiCheckbox'] => ({
  styleOverrides: {
    sizeSmall: {
      padding: '7px',
    },
  },
});
